module.exports = __webpack_public_path__ + "static/img/dingzhi.d5719e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dingzhi.png
// module id = MQrR
// module chunks = 21